import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import CaseStatusSticker from 'dashboard/components/CaseStatusSticker';
import { CaseState, ChecklistItem } from 'dashboard/models/case-template';
import Spacer from 'design-system/components/Spacer';
import { Label } from 'design-system/components/Text';

const InvalidChecklistItemsDescription = styled('div')`
  margin-top: 8px;
`;

const StyledCaseSticker = styled(CaseStatusSticker)`
  padding-right: ${Spacing[1]};
`;

const StickerGroup = styled('div')`
  display: inline-flex;
  flex-wrap: wrap;
  gap: ${Spacing[1]};
  padding-right: ${Spacing[1]};
`;

const InvalidItemEntry = styled('div')`
  border-bottom: 1px solid ${Color.CoreSlate50};
  padding: 16px;
`;

interface AutocorrectChecklistItemsDescriptionProps {
  states: CaseState[];
  invalidStates: Set<CaseState>;
  invalidChecklistItems: Set<ChecklistItem>;
}

export const AutocorrectChecklistItemsDescription = ({
  states,
  invalidStates,
  invalidChecklistItems,
}: AutocorrectChecklistItemsDescriptionProps) => {
  const description = `${
    invalidStates.size > 1 ? 'have' : 'has'
  } been removed from the template and will be removed as a requirement from the following ${
    invalidChecklistItems.size > 1 ? 'items:' : 'item:'
  }`;
  return (
    <div data-test='invalid-checklist-items-details'>
      <Label size='lg' weight='bold'>
        Corrections for checklist items
      </Label>
      <InvalidChecklistItemsDescription data-test='invalid-checklist-items-description'>
        <StickerGroup>
          {Array.from(invalidStates).map((state) => (
            <StyledCaseSticker key={`invalid-states_${state.token}`} caseState={state} />
          ))}
        </StickerGroup>
        <span>{description}</span>
      </InvalidChecklistItemsDescription>
      {Array.from(invalidChecklistItems).map((item, i) => (
        <InvalidItemEntry
          data-test={`invalid-checklist-item_${i}`}
          key={`invalid-checklist-item_${i}`}
        >
          {item.description}
          <Spacer height={1} />
          <StickerGroup data-test={`invalid-checklist-item_${i}-states`}>
            {item['required-for'].map((stateId: string) => {
              const state = states.find((state) => state.token === stateId);
              /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
              return <CaseStatusSticker key={`checklist-item-${i}_${stateId}`} caseState={state} />;
            })}
          </StickerGroup>
        </InvalidItemEntry>
      ))}
    </div>
  );
};

export default AutocorrectChecklistItemsDescription;
